import instance from "../api-provider";

export const searchMember = async (payload, token) => {
  try {
    let response = await instance({
      url: `/member/searchMember`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};
